import LegalLayout, { Sections } from "./LegalLayout";
import { useLegal } from "./content";

export default function Privacy() {
  const { privacy: p } = useLegal();
  return (
    <LegalLayout testid="privacy-page" kicker={p.kicker} title={p.title} intro={p.intro} toc={p.sections}>
      <Sections sections={p.sections} />
    </LegalLayout>
  );
}
